import { render } from "./submit-offer.vue?vue&type=template&id=00d65e3d"
import script from "./submit-offer.vue?vue&type=script&lang=js"
export * from "./submit-offer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__